import { Injectable } from '@angular/core';
import { CustomHttpService } from "@services/generals/custom-http.service";
import { MyForm } from "@models/my-form";

@Injectable({providedIn: 'root'})
export class MyFormService {
  public data: any;
  constructor(
    public customHttpService: CustomHttpService
  ) {
  }

  public sendForm = (myForm: MyForm) => {
    const self = this;
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(true, true, 'v1/api/FrmNDA', myForm).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response['data'];
            resolve(true);
          }
        );
      }
    );
  }

  public getUserInfo = (userID: string) => {
    const self = this;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, '/v1/api/FrmNDA/GetEmployeeByEmployee_Nomber/' + userID).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response['data'];
            resolve(true);
          }
        );
      }
    );
  }
}
